import { GetStaticPathsResult, GetStaticPropsContext, GetStaticPropsResult } from 'next';
import React from 'react';

import { PageFooter } from '../../components/organisms/page-footer';
import SEO from '../../components/organisms/seo';
import { PageTemplate } from '../../components/templates/page-template';
import { fetchPolicy } from '../../utils/policies';

interface Props {
  content: string;
  title?: string;
}

const PolicyPage: React.FC<Props> = (props) => {
  let { content, title } = props;

  return (
    <PageTemplate>
      <SEO title={title} description={title} />

      <header className="relative h-16 bg-brand-500">
        <div className="absolute z-10 h-full w-full">
          <div className="max-w-screen-xl mx-auto py-2 px-8 h-full flex items-center justify-between text-white">
            <a href="/" className="font-bold text-lg">
              Woyti
            </a>
          </div>
        </div>
      </header>

      <div className="max-w-screen-xl mx-auto px-8 my-8">
        <div className="md-content mb-4" dangerouslySetInnerHTML={{ __html: content }} />

        <PageFooter />
      </div>
    </PageTemplate>
  );
};

export async function getStaticProps(context: GetStaticPropsContext): Promise<GetStaticPropsResult<Props>> {
  try {
    let policyName = context.params?.policy;
    let cleanedPolicyName = Array.isArray(policyName) ? policyName.join('-') : policyName;
    let policy = await fetchPolicy(cleanedPolicyName ?? '-', context.locale ?? 'en');

    if (!policy) {
      throw new Error(`Policy ${cleanedPolicyName} not found`);
    }

    return {
      props: {
        content: policy.html,
        title: policy?.data?.title || 'Policy',
      },
    };
  } catch (err) {
    console.error(err);

    return {
      notFound: true,
    };
  }
}

export function getStaticPaths(): GetStaticPathsResult {
  return {
    paths: [],
    fallback: 'blocking',
  };
}

export default PolicyPage;
